export { default } from "./InfoRecommendationView";
